<!-- ToDo: Needed to wrap this into a div to prevent menu from being cut off on mobile. -->
<!--<div class="force-gpu">-->
<!--  <router-outlet></router-outlet>-->
<!--</div>-->
<!-- ToDo: Test -->
<router-outlet></router-outlet>

<!-- New-version-available prompt (preventive) -->
<app-update-banner></app-update-banner>

<!-- Chunk-load recovery fallback (last resort) -->
<app-load-failure></app-load-failure>
